import type React from 'react';
import { Spacer as ChakraSpacer } from '@chakra-ui/react';
import HeroSection from '@/components/rulesMarketing/HeroSection';
import PredictSection from '@/components/rulesMarketing/PredictSection';
import ChooseSeedsSection from '@/components/rulesMarketing/ChooseSeedsSection';
import CollectPointsSection from '@/components/rulesMarketing/CollectPointsSection';
import JoinLeagueSection from '@/components/rulesMarketing/JoinLeagueSection';
import FAQSection from '@/components/rulesMarketing/FAQSection';

type RulesIntroSectionsProps = {
  onClickCTA: () => void;
};

export function RulesIntroSections({ onClickCTA }: RulesIntroSectionsProps) {
  return (
    <>
      <Spacer mt='1em' />
      <HeroSection onClickCTA={onClickCTA} />
      <Spacer />
      <PredictSection />
      <Spacer />
      <ChooseSeedsSection />
      <Spacer />
      <CollectPointsSection />
      <Spacer />
      <JoinLeagueSection onClickCTA={onClickCTA} />
      <Spacer />
      <FAQSection />
    </>
  );
}

const Spacer: React.FC<{ mt?: string | number }> = ({ mt }) => {
  const config = {
    base: '1.5rem',
    md: '2.25rem',
    lg: '3rem',
    xl: '3.5rem',
  };
  return <ChakraSpacer mt={mt ?? config} />;
};
